import { useCallback, useState } from 'react';
import { getSettings, updateExecuteKey } from 'api/settingsApi';
import { useLoginContext } from 'components/providers/loginContext';
import { generateUuid } from 'utils/commonService';
import { Annotation, SETTINGS_ANNOTATION } from 'constants/constants';

export function useSettings(): [
  (
    wfId: number,
    serviceClass: string,
    appKey?: string,
  ) => Promise<Annotation | undefined>,
  () => Promise<Annotation | undefined>,
  string,
  boolean,
] {
  const loginContext = useLoginContext();
  const [executeKey, setExecuteKey] = useState<string>('');
  const [loading, setLoading] = useState(false);

  // 指定した wfIdとserviceClass で 設定情報を取得する
  const handleGetSettings = useCallback(
    async (
      wfId: number,
      serviceClass: string,
      appKey?: string,
    ): Promise<Annotation | undefined> => {
      setLoading(true);
      try {
        if (loading) return;
        // 設定情報を取得する
        const settings = await getSettings(
          wfId,
          serviceClass,
          loginContext,
          appKey,
        );

        setExecuteKey(settings.executeKey);

        setLoading(false);
        return;
      } catch (e) {
        setLoading(false);
        return SETTINGS_ANNOTATION.GET_FAILED;
      }
    },
    [loading, loginContext],
  );

  // execute-Key を再発行する
  const handleUpdateExecuteKey = useCallback(async (): Promise<
    Annotation | undefined
  > => {
    setLoading(true);
    try {
      if (loading) return;

      // execute-Key を再発行する
      const executeKeyNew = generateUuid();
      await updateExecuteKey(executeKey, executeKeyNew, loginContext);

      setExecuteKey(executeKeyNew);
      setLoading(false);
      return SETTINGS_ANNOTATION.UPDATE_SUCCESS;
    } catch (e) {
      setLoading(false);
      return SETTINGS_ANNOTATION.UPDATE_FAILED;
    }
  }, [executeKey, loading, loginContext]);

  return [handleGetSettings, handleUpdateExecuteKey, executeKey, loading];
}
